import { Component, OnInit } from '@angular/core'

@Component({
    selector: 'app-organizer-billing',
    templateUrl: './organizer-billing.component.html',
})
export class OrganizerBillingComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
